import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
const ApplicationmasterListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalPages, currentPage, limit, setPrevPage, setNextPage } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/applicationmaster/view/${data.applicationid}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('applicationmaster/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/applicationmaster/edit/${data.applicationid}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('applicationmaster/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.applicationid) },
			icon: "pi pi-trash",
			visible: () => auth.canView('applicationmaster/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function ApplicationidTemplate(data){
		if(data){
			return (
				<Link to={`/applicationmaster/view/${data.applicationid}`}> { data.applicationid }</Link>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div  className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-applicationmaster`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
	return (
		<div className="flex-grow-1">
			<div className="flex  justify-content-center">
				<div  className="m-2">
					<Button disabled={pagination.currentPage <= 1} label="Previous" onClick={()=>pagination.setPrevPage()} icon="pi pi-arrow-left" />
				</div>
				<div className="m-2">
					<Button disabled={pagination.currentPage >= totalPages} label="Next" onClick={()=>pagination.setNextPage()} icon="pi pi-arrow-right" icon-pos="right" />
				</div>
			</div>
		</div>
	)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="applicationmaster/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="ApplicationmasterListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('loanApplication')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <CanView pagePath="">
                        <Link to={`/applicationmaster/add`}>
                            <Button label={$t('addNewApplicationmaster')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                            </Link>
                        </CanView>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                    value={records} 
                                    dataKey="applicationid" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className=" p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                    <Column  field="applicationid" header={$t('applicationid')} body={ApplicationidTemplate} sortable={true} ></Column>
                                    <Column  field="fullname" header={$t('fullname')}  sortable={true} ></Column>
                                    <Column  field="firstname" header={$t('firstname')}  sortable={true} ></Column>
                                    <Column  field="lastname" header={$t('lastname')}  sortable={true} ></Column>
                                    <Column  field="dob" header={$t('dob')}  sortable={true} ></Column>
                                    <Column  field="gender" header={$t('gender')}  sortable={true} ></Column>
                                    <Column  field="additionalname1" header={$t('additionalname1')}  sortable={true} ></Column>
                                    <Column  field="additionalname2" header={$t('additionalname2')}  sortable={true} ></Column>
                                    <Column  field="nationalid" header={$t('nationalid')}  sortable={true} ></Column>
                                    <Column  field="voterid" header={$t('voterid')}  sortable={true} ></Column>
                                    <Column  field="mobile" header={$t('mobile')}  sortable={true} ></Column>
                                    <Column  field="addrline1" header={$t('addrline1')}  sortable={true} ></Column>
                                    <Column  field="city" header={$t('city')}  sortable={true} ></Column>
                                    <Column  field="state" header={$t('state')}  sortable={true} ></Column>
                                    <Column  field="postal" header={$t('postal')}  sortable={true} ></Column>
                                    <Column  field="maritalstatus" header={$t('maritalstatus')}  sortable={true} ></Column>
                                    <Column  field="loan_amount" header={$t('loanAmount')}  sortable={true} ></Column>
                                    <Column  field="loan_purpose" header={$t('loanPurpose')}  sortable={true} ></Column>
                                    <Column  field="aadhar_verify" header={$t('aadharVerify')}  sortable={true} ></Column>
                                    <Column  field="pan_verify" header={$t('panVerify')}  sortable={true} ></Column>
                                    <Column  field="bank_statement_verify" header={$t('bankStatementVerify')}  sortable={true} ></Column>
                                    <Column  field="average_bank_balance" header={$t('averageBankBalance')}  sortable={true} ></Column>
                                    <Column  field="credit_verify" header={$t('creditVerify')}  sortable={true} ></Column>
                                    <Column  field="credit_schore" header={$t('creditSchore')}  sortable={true} ></Column>
                                    <Column  field="credit_eligible" header={$t('creditEligible')}  sortable={true} ></Column>
                                    <Column  field="address_verify" header={$t('addressVerify')}  sortable={true} ></Column>
                                    <Column  field="overall_status" header={$t('overallStatus')}  sortable={true} ></Column>
                                    <Column  field="eligible_loan_amount" header={$t('eligibleLoanAmount')}  sortable={true} ></Column>
                                    <Column  field="interest_rate" header={$t('interestRate')}  sortable={true} ></Column>
                                    <Column  field="tenure" header={$t('tenure')}  sortable={true} ></Column>
                                    <Column  field="processing_fee" header={$t('processingFee')}  sortable={true} ></Column>
                                    <Column  field="emi" header={$t('emi')}  sortable={true} ></Column>
                                    <Column  field="ecs_authorized" header={$t('ecsAuthorized')}  sortable={true} ></Column>
                                    <Column  field="bank_accountnumber" header={$t('bankAccountnumber')}  sortable={true} ></Column>
                                    <Column  field="bank_ifsc" header={$t('bankIfsc')}  sortable={true} ></Column>
                                    <Column  field="middlename" header={$t('middlename')}  sortable={true} ></Column>
                                    <Column  field="pancard" header={$t('pancard')}  sortable={true} ></Column>
                                    <Column  field="userid" header={$t('userid')}   ></Column>
                                    <Column  field="app_date" header={$t('appDate')}   ></Column>
                                    <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                            </div>
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
ApplicationmasterListPage.defaultProps = {
	primaryKey: 'applicationid',
	pageName: 'applicationmaster',
	apiPath: 'applicationmaster/index',
	routeName: 'applicationmasterlist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default ApplicationmasterListPage;
